var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrid4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 16,
    viewBox: "0 0 16 16",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1H7V7H1V1Z",
    fill: "#030708"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 1H15V7H9V1Z",
    fill: "#030708"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 9H7V15H1V9Z",
    fill: "#030708"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 9H15V15H9V9Z",
    fill: "#030708"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid4);
export default __webpack_public_path__ + "static/media/grid4.cfea05ea0adf5b8cefd334965a29d779.svg";
export { ForwardRef as ReactComponent };